import moment from "moment";
import seedrandom from "../tools/seedrandom";
import { GeneratorParams, COLUMN_ID } from "./generator";
import { AppView, Sorting } from "../SettingsProvider";
import { StatType } from "../tools/stats";

const random = seedrandom("myseed");

const names = [
    "What do you mean?",
    "Ni! Ni! Ni! Ni!",
    "I have to push the pram a lot",
    "The coconut's tropical",
    "You don't frighten us, English pig-dogs!",
    "Go and boil your bottoms",
    "On second thoughts, let's not go there",
    "Now, look here, my good man",
    "She turned me into a newt",
    "It's only a model",
    "Did you dress her up like this?",
    "Your mother was a hamster and your father smelt of elderberries!",
    "Supreme executive power",
    "I'm not a witch",
    "And this isn't my nose",
    "The swallow may fly south with the sun",
    "We found them",
    "I, Arthur, was to carry Excalibur",
    "We shall say 'Ni' again to you",
    "Knights of Ni, we are but simple travelers",
    "I blow my nose at you, so-called Ah-thoor Keeng",
    "Strange women lying in ponds distributing swords",
    "I don't want to talk to you no more",
    "I bid you welcome to your new home",
    "Must be a king"
];

// project start
const creationT = moment("2020-01-01 12:00:00");

// variation of creation times
const creationDt = 1000 * 60 * 60 * 24 * 2; // 2 d

const dayMs = 1000 * 60 * 60 * 24;

const params: GeneratorParams = {
    random,
    statuses: ["Backlog", "In Design", "In Development", "UAT", "Ready for release", "Done"],
    skipStatusChance: [0, 0, 0, 0, 0, 0],
    names,
    creationTimes: names.map(() => creationT.clone().add(Math.floor(random() * creationDt), "ms")),
    itemSpeedFactor: names.map(() => 0.1 + random() * 0.9),
    minStatusT: [dayMs * 1, dayMs * 1, dayMs * 1, dayMs * 1, dayMs * 1, dayMs * 1],
    statusDt: [dayMs * 2, dayMs * 2, dayMs * 2, dayMs * 2, dayMs * 2, dayMs * 2], // per status
    mondayContext: {
        boardIds: ["_demo_demo3"],
        instanceId: "_demo_demo3",
        instanceType: "board_view",
        editMode: true,
        theme: "dark",
        viewMode: "fullscreen"
    },
    mondaySettings: {
        view: AppView.REPLAY,
        column: COLUMN_ID,
        autoupdate: false,
        from: creationT,
        to: creationT.clone().add(3, "month"),
        itemSorting: Sorting.SELECTED_STATUSES_TIME_DESC,
        showStats: [StatType.MEDIAN, StatType.MAX, StatType.P90],
        statsShowUnselectedBars: false,
        statsCompareAgainst: StatType.MEDIAN,
        showPrevNextEvents: true,
        showProgress: true
    }
};

export default params;
